package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p1
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p45
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.views.AppTheme

@Composable
fun IconText(
    modifier  : Modifier    = Modifier,
    text      : String,
    icon      : Painter,
    iconColor : Color?      = null,
    iconSize  : Dp          = p24,
    divider   : Boolean     = false
) {
    Row(
        modifier                = modifier,
        horizontalArrangement   = Arrangement.spacedBy(p16),
        verticalAlignment       = Alignment.CenterVertically
    ) {
        Image(
            modifier            = Modifier.size(iconSize),
            painter             = icon,
            colorFilter         = ColorFilter.tint(iconColor ?: AppTheme.current.colors.onSurface)
        )
        Texts.BodyMedium(text = text)
    }
    
    if (divider)
        HorizontalDivider(thickness = p1, modifier = Modifier.padding(top = p8, start = p45))
}